module.exports = __webpack_public_path__ + "media/images/safari-pinned-tab-59987f8ee340287da0ec4f2a0fe22ba6.svg";